import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Col, Icon, Row, Table } from 'antd'
import { userStatus, userRelations } from '@texts/users'
import ChooseClientPagePopup from '@components/Popup/ChooseClientPagePopup'
import { isCoordinatorOnly } from '@utils/roles'
import * as style from './style.scss'

@inject((store: any) => {
    const { popupStore, subscriptionsStore, roleStore, authStore } = store
    return { popupStore, subscriptionsStore, roleStore, authStore }
})
@observer
class List extends Component<any> {
    async componentDidMount() {
        const { subscriptionsStore } = this.props
        await subscriptionsStore.getSubscriptions()
    }
    filterRoles(record) {
        const { slugs } = this.props.roleStore

        if (record.roles) {
            const roleSlugs = record.roles.map(o => o.slug)

            if (roleSlugs.includes('agent') && roleSlugs.includes('insurance_agent')) {
                return record.roles
                    .filter(r => r.slug !== 'agent')
                    .map(role => slugs[role.slug])
                    .join(', ')
            }

            return record.roles.map(role => slugs[role.slug]).join(', ')
        }
    }
    isOnlyAgent(roles) {
        return roles.length > 0
            ? roles.length <= 2 && (roles[0].slug === 'agent' || roles[0].slug === 'insurance_agent')
            : false
    }

    render() {
        const {
            data,
            loading,
            popupStore: { togglePopup },
            history,
            updatePage,
            authStore: { roles: currentUserRoles }
        } = this.props
        const coordinatorOnly = isCoordinatorOnly(currentUserRoles)

        const columns = [
            {
                title: 'שם פרטי',
                key: 'first_name',
                render: (_, record) => <span>{record.first_name}</span>
            },
            {
                title: 'שם משפחה',
                key: 'last_name',
                render: (_, record) => <span>{record.last_name}</span>
            },
            {
                title: 'שיוך משפחתי',
                key: 'family',
                render: (_, record) => (
                    <span>
                        {record.parent_id && record.related_as
                            ? `משוייך למשתמש (${record.parent_id}) כ${userRelations[record.related_as]}`
                            : ''}
                    </span>
                )
            },
            {
                title: 'סוג משתמש',
                key: 'user_type',
                render: (_, record) => (
                    <span>
                        {record.phone && record.status === 'COMPLETE' ? 'בעל גישה' : record.phone ? 'ראשי' : 'משני'}
                    </span>
                )
            },
            {
                title: 'בעל מנוי',
                key: 'subscription_id',
                render: (_, record) => (
                    <span>
                        {record.userSubscriptions && record.userSubscriptions.length > 0
                            ? record.userSubscriptions.map(sub =>
                                  ['BLOCKED', 'AWAITING_BANK_TRANSFER'].includes(sub.status) ? (
                                      <span style={{ color: 'red', fontWeight: 'bold' }}>{'חסום עד להסדרת תשלום'}</span>
                                  ) : (
                                      sub.name
                                  )
                              )
                            : record.parentSub &&
                              record.parentSub.map(sub =>
                                  ['BLOCKED', 'AWAITING_BANK_TRANSFER'].includes(sub.status) ? (
                                      <span style={{ color: 'red', fontWeight: 'bold' }}>{'חסום עד להסדרת תשלום'}</span>
                                  ) : (
                                      'חלק מ' + sub.name
                                  )
                              )}
                    </span>
                )
            },
            {
                title: 'טלפון',
                key: 'phone',
                render: (_, record) => <span>{record.phone}</span>
            },
            {
                title: 'מצב',
                key: 'status',
                render: (_, record) => (
                    <span>
                        {record.status && userStatus[record.status] ? (
                            userStatus[record.status]
                        ) : this.isOnlyAgent(record.roles) ? (
                            'סוכן שלא נרשם כלקוח'
                        ) : (
                            <strong style={{ color: 'red' }}>
                                <Icon type="close" /> כשל בהרשמה
                            </strong>
                        )}
                    </span>
                )
            },
            {
                title: 'תפקיד',
                key: 'role',
                render: (_, record) => <span>{this.filterRoles(record)}</span>
            },
            {
                title: 'מזהה',
                key: 'id',
                render: (_, record) => <span>{record.id}</span>
            }
        ]

        return (
            <>
                <Row>
                    <Col>
                        <div className="box">
                            {data.data ? (
                                <Table
                                    className="center-table"
                                    style={{ width: '100%' }}
                                    rowKey="id"
                                    loading={loading}
                                    columns={columns}
                                    rowClassName={record =>
                                        record.status || this.isOnlyAgent(record.roles)
                                            ? style.user_row
                                            : style.no_status
                                    }
                                    dataSource={data.data.filter(
                                        (item, idx) => idx == data.data.map(item => item.id).indexOf(item.id)
                                    )}
                                    pagination={{
                                        total: data.total,
                                        pageSize: data.perPage,
                                        current: data.page,
                                        onChange: value => updatePage(value)
                                    }}
                                    onRow={record => {
                                        return {
                                            onClick: () => {
                                                let roles = (record.roles || []).map(role => role.slug)
                                                let isAgent =
                                                    roles.includes('agent') ||
                                                    roles.includes('insurance_agent') ||
                                                    roles.includes('distributors_manager') ||
                                                    roles.includes('sales') ||
                                                    roles.includes('collective')
                                                if (isAgent) {
                                                    if (roles.includes('customer') && !coordinatorOnly) {
                                                        togglePopup('chooseClientPopup', record.id)
                                                    } else {
                                                        history.push(`/agents/${record.id}`)
                                                    }
                                                } else {
                                                    history.push(`/clients/${record.id}`)
                                                }
                                            }
                                        }
                                    }}
                                />
                            ) : (
                                ''
                            )}
                        </div>
                    </Col>
                </Row>
                <ChooseClientPagePopup />
            </>
        )
    }
}

export default withRouter(List)
